import ICAL from "ical.js";

export function icalToEvents(icalData) {
    const jcalData = ICAL.parse(icalData);
    const comp = new ICAL.Component(jcalData);
    const vevents = comp.getAllSubcomponents("vevent");
    const events = vevents.map((vevent) => {
        const event = new ICAL.Event(vevent);
        return {
            title: event.summary,
            start: event.startDate.toJSDate(),
            startStr: event.startDate.toString(),
            end: event.endDate.toJSDate(),
            endStr: event.endDate.toString(),
            location: event.location,
            description: event.description,
            id: event.uid,
        };
    });
    return events;
}